export default "__VITE_ASSET__Dj2Yl77X__"